module.exports = __webpack_public_path__ + "img/3.5b4d5182.png";